<div class="loading-modal" *ngIf="show">
  <div class="loading-container" >
    <div class="compass">
      <svg class="compass-base" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <circle cx="50" cy="50" r="40" stroke="#333" stroke-width="10" fill="transparent" />
        <line x1="50" y1="25" x2="50" y2="10" stroke="#333" stroke-width="10" />
        <line x1="50" y1="75" x2="50" y2="90" stroke="#333" stroke-width="10" />
        <line x1="25" y1="50" x2="10" y2="50" stroke="#333" stroke-width="10" />
        <line x1="75" y1="50" x2="90" y2="50" stroke="#333" stroke-width="10" />
      </svg>
      <svg class="compass-needle" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <line x1="50" y1="10" x2="50" y2="50" stroke="red" stroke-width="20" />

        <line x1="50" y1="50" x2="50" y2="90" stroke="black" stroke-width="20" />
      </svg>
    </div>
    <p class="loading-text">Cargando...</p>
  </div>

</div>
